<div class="flex gap-0.5 mt-1">
    @if (isLockedIn) {
        <p-button
            severity="secondary"
            size="small"
            styleClass="!w-[15px] !p-0 tiny aspect-square !rounded">
            <fa-icon [icon]="faLock" style="font-size: 10px" />
        </p-button>
    }
    @if (isQuietMode) {
        <p-button
            severity="secondary"
            size="small"
            styleClass="!w-[15px] !p-0 tiny aspect-square !rounded">
            <fa-icon [icon]="faMicrophoneAltSlash" style="font-size: 10px" />
        </p-button>
    }
    @if (showActivityType) {
        <p-button
            severity="secondary"
            class="h-[15px] !w-[15px]"
            size="small"
            styleClass="!w-[15px] !p-0 tiny aspect-square !rounded">
            <fa-icon [icon]="activityIcon" style="font-size: 10px" />
        </p-button>
    }
    @if (durationString) {
        <p-button
            severity="secondary"
            class="h-[15px] !w-[15px]"
            size="small"
            styleClass="!w-[15px] !p-0 tiny aspect-square !rounded">
            <div style="font-size: 10px">{{ durationString }}</div>
        </p-button>
    }
</div>
